import { Button, Card, CardActions, CardContent, CardHeader, Divider, Table, TableBody, TableCell, TableRow } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { ModuleEdit } from './components';
import snakeToCamel from 'utils/snakeToTitle';

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  actions: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    '& > * + *': {
      marginLeft: 0
    }
  },
  buttonIcon: {
    marginRight: theme.spacing(1)
  },
  header: {
    fontWeight: 600
  }
}));

const ModuleInfo = props => {
  const { className, ...rest } = props;
  const model = useSelector(state => state.models.module);

  const classes = useStyles();

  const [openEdit, setOpenEdit] = useState(false);

  const handleEditOpen = () => {
    setOpenEdit(true);
  };

  const handleEditClose = () => {
    setOpenEdit(false);
  };

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardHeader title="Module Info" />
      <Divider />
      <CardContent className={classes.content}>
        <Table>
          <TableBody>
            <TableRow>
              <TableCell className={classes.header}>Name</TableCell>
              <TableCell>{model.name_en}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.header}>Name (ZH)</TableCell>
              <TableCell>{model.name_zh}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.header}>Code</TableCell>
              <TableCell>{model.code}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.header}>Family</TableCell>
              <TableCell>{snakeToCamel(model.family)}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.header}>Type</TableCell>
              <TableCell>{snakeToCamel(model.type)}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.header}>Specialisation</TableCell>
              <TableCell>{snakeToCamel(model.specialisation)}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.header}>Requirement</TableCell>
              <TableCell>{snakeToCamel(model.requirement)}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.header}>Description</TableCell>
              <TableCell>{model.description_en}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.header}>Description (ZH)</TableCell>
              <TableCell>{model.description_zh}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </CardContent>
      <CardActions className={classes.actions}>
        <Button onClick={handleEditOpen}>
          <EditIcon className={classes.buttonIcon} />
          Edit
        </Button>
      </CardActions>
      <ModuleEdit onClose={handleEditClose} open={openEdit} />
    </Card>
  );
};

ModuleInfo.propTypes = {
  className: PropTypes.string,
};

export default ModuleInfo;
